export default {
    url: '/quizzes',
    template: '<materials-quizzes/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/quizzes/index.js